var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-row',[_c('v-col',{staticClass:"col-12 d-flex justify-center align-center align-content-center"},[_c('v-col',{staticClass:"col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 bg"},[_c('LoginForm')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }